<template>
  <v-container id="top-nav-container" ref="top-nav-ref" pa-0 mt-2>
    <v-layout
      align-center
      justify-center
      row
      mx-1
      ref="tour-icon-container"
    >
      <v-flex
        pt-1
        v-for="(restaurant, i) in restaurants"
        justify-center
        d-flex
        :key="restaurant.name"
        :ref="'tour-icon-' + (i + 1)"
      >
        <v-layout column justify-center align-center>
          <v-flex v-if="i === currentRestaurantIndex">
            <v-img :src="tourPin" width="16px" height="25px" />
          </v-flex>
          <v-flex v-else>
            <v-avatar size="20"> </v-avatar>
          </v-flex>
          <v-flex>
            <v-avatar
              :size="tourIconWidth"
              @click.stop="navigateToRestaurantIndex(i)"
            >
              <v-img
                :src="
                  i === currentRestaurantIndex
                    ? restaurantIcons['active'][restaurant.iconType]
                    : restaurantIcons['inactive'][restaurant.iconType]
                "
              />
            </v-avatar>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import TourPin from "../../assets/tourpin.png";
import savoryActive from "../../assets/restaurantIcons/active/savory_active.png";
import sweetActive from "../../assets/restaurantIcons/active/sweet_active.png";
import noneActive from "../../assets/restaurantIcons/active/store_active.png";
import savoryInactive from "../../assets/restaurantIcons/inactive/savory_inactive.png";
import sweetInactive from "../../assets/restaurantIcons/inactive/sweet_inactive.png";
import noneInactive from "../../assets/restaurantIcons/inactive/store_inactive.png";
export default {
  name: "top-nav-container",
  props: ["restaurants"],
  data() {
    return {
      tourIconWidth: "",
      restaurantIcons: {
        active: {
          savory: savoryActive,
          sweet: sweetActive,
          none: noneActive,
        },
        inactive: {
          savory: savoryInactive,
          sweet: sweetInactive,
          none: noneInactive,
        },
      },
      // restaurants: '',
      tourPin: TourPin,
      restaurantListLength: null,
    };
  },
  methods: {
    // importSelectedRestaurantIcons() {
    //   var restaurants = this.$store.getters.userTour.restaurants
    //   var restaurantKeys = Object.keys(restaurants)
    //   restaurantKeys.forEach((k, i) => {
    //     var iconKey = restaurants[k].iconType
    //     this.restaurantIcons.active = {
    //       ...this.restaurantIcons.active,
    //       [iconKey]: require(`../../assets/restaurantIcons/active/${iconKey}.png`)
    //     }
    //     this.restaurantIcons.inactive = {
    //       ...this.restaurantIcons.inactive,
    //       [iconKey]: require(`../../assets/restaurantIcons/inactive/${iconKey}.png`)
    //     }
    //   })
    // },
    // getIcon(key, active) {
    //   var iconName = this.$store.getters.userTour.restaurants[key].iconType
    //   var attr = active ? 'active' : 'inactive'
    //   var icon = this.restaurantIcons[attr][iconName]
    //   return icon
    // },
    // getIconName(key) {
    //   return this.$store.getters.userTour.restaurants[key].iconType
    // },
    calculateFlexWidth() {
      this.tourIconWidth =
        (this.$refs["tour-icon-container"].clientWidth - 5 * 6) /
        this.restaurantListLength;
    },
    navigateToRestaurantIndex(i) {
      //console.log('Navigate to ', i)
      if (i <= this.maxRestaurantIndex) {
        console.log("In here");
        this.$store.dispatch("navigateToPreviousRestaurant", i);
      }
    },
  },
  mounted() {
    //console.log('hello in Nav')
    this.restaurantListLength = this.$store.getters.restaurantListLength;
    this.calculateFlexWidth();
    //this.restaurants = this.$store.getters.restaurants

    //this.importSelectedRestaurantIcons()
  },
  computed: {
    currentRestaurantIndex() {
      return this.$store.getters.currentRestaurantIndex;
    },
    // restaurantListLength() {
    //   return this.restaurants.length
    // },
    maxRestaurantIndex() {
      return this.$store.getters.maxRestaurantIndex;
    },
  },
};
</script>

<style scoped>
#top-nav-container {
  background-color: Transparent;
  position: absolute;
  top: 0;
  z-index: 50;
  width: 100%;
}

#tour-icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
}

#background {
  background-color: black;
  height: 100px;
  width: 100%;
  position: fixed;
  top: 0;
  opacity: 0.3;
}

#tester {
  height: 120px;
  background-color: red;
}
</style>
